// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__2QdJ4","editIcon":"style_editIcon__oS6KU","deletedIcon":"style_deletedIcon__2Y48w","newIcon":"style_newIcon__2Sod7"};